import React from "react";
import { compose, graphql } from "react-apollo";

import translateErrorMessage from "utils/translateErrorMessage";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import { ACTUATORS_QUERY } from "../generalRegisterQueries";
import { CREATE_ACTUATOR_MUTATION } from "../generalRegisterMutations";
import ActuatorModal from "./ActuatorModal";

const ActuatorCreate = ({
  createActuator,
  snackbarContext,
  toggleModal,
  isOpen,
}) => {
  const onSave = (actuator) => {
    createActuator({
      variables: {
        params: actuator
      },
      refetchQueries: [{
        query: ACTUATORS_QUERY
      }]
    })
      .then(() => {
        snackbarContext.setNotificationTimeOut(Color.success, "Atuador criado.");
        toggleModal();
      })
      .catch(error => {
        snackbarContext.setNotificationTimeOut(Color.danger, translateErrorMessage(error));
      });
  };

  return (
    <ActuatorModal
      toggleModal={toggleModal}
      isOpen={isOpen}
      title="Cadastrar atuador"
      onSave={onSave}
      isCreate
    />
  );
};

export default compose(
  graphql(CREATE_ACTUATOR_MUTATION, { name: "createActuator", }),
  withSnackbarConsumer,
)(ActuatorCreate);
